export const config = {
  platformName: "TicketHall",
  platformFeePercent: 7,
  // PAYMENT_INTEGRATION_POINT: add payment gateway keys here
  // pagarmeApiKey: import.meta.env.VITE_PAGARME_KEY,
  // mercadoPagoPublicKey: import.meta.env.VITE_MP_PUBLIC_KEY,
};
